<template>
  <div class="news-files" id="docsElement" :class="{ liferecad }">
    <div class="news-files-header" :style="{ backgroundColor: color }">
      <FileIcon :folder="true" />
      {{ $t("documents") }}
      <img
        src="@/assets/img/liferecad_logo.svg"
        alt="Liferecad"
        class="liferecad-logo"
        v-if="liferecad"
      />
    </div>
    <div class="news-files-table">
      <table>
        <tr
          v-for="(f, i) in files[$i18n.locale]"
          :key="`file-${i}`"
          @click="goToFile(liferecad ? f[0] : f)"
        >
          <template v-if="liferecad">
            <td>
              <img src="../../../../assets/img/icons/liferecad_file.svg" />
            </td>

            <td>
              <p>{{ f[1] }}</p>
              <p class="mobile">
                {{ f[2] }}
              </p>
            </td>
            <td class="desktop">{{ f[2] }}</td>
          </template>
          <template v-else>
            <td>
              <FileIcon :folder="false" :name="f" />
            </td>
            <td>{{ f }}</td>
          </template>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import FileIcon from "./FileIcon";
export default {
  components: {
    FileIcon,
  },
  props: ["files", "color", "liferecad"],
  methods: {
    goToFile(f) {
      if (!f) {
        this.$snotify.error(this.$t("missing-file"));
        return;
      }

      if (this.liferecad) {
        window.open(
          `${process.env.VUE_APP_FILES_URI}/liferecad/${this.$i18n.locale}/${f}`
        );
      } else {
        window.open(
          `${process.env.VUE_APP_FILES_URI}/products/${this.$i18n.locale}/${f}`
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.news-files {
  margin-top: 15px;
  position: relative;
  width: 100%;
  .news-files-header {
    @extend %flex-center;
    color: #fff;
    height: 44px;
    justify-content: flex-start;
    margin-bottom: 8px;
    padding: 10px;
    position: relative;
    // width: 420px;
    z-index: 2;
    img {
      height: 28px;
      margin-right: 10px;
      width: 32px;
    }
  }
  .news-files-table {
    overflow: auto;
    position: relative;
    width: 100%;
    z-index: 2;
    table {
      width: 100%;
      tr {
        cursor: pointer;
        td {
          background-color: #fff;
          border-bottom: 1px solid #f7f7f7;
          padding: 10px;
          vertical-align: middle;

          p {
            &:nth-child(1) {
              text-decoration: none;
              font-weight: 500;
            }
            &:nth-child(2) {
              color: #666666;
              font-size: 12px;
            }
          }

          .mobile {
            display: none;
          }
        }
        @media screen and (max-width: 800px) {
          .mobile {
            display: initial !important;
          }
          .desktop {
            display: none;
          }
        }

        td:first-child {
          padding-left: 25px;
          width: 1%;
        }
        td:last-child {
          padding-right: 25px;
          &:nth-child(3) {
            color: #666666;
            font-size: 12px;
          }
        }
      }
      tr:hover {
        td {
          text-decoration: none;
          background-color: #f5f5f5;
        }
      }
    }
  }
  &::before {
    background-color: #eaeef0;
    content: "";
    height: 100px;
    left: 25px;
    position: absolute;
    top: 20px;
    width: calc(100% - 50px);
    z-index: 1;
  }

  &.liferecad {
    .news-files-header {
      height: 70px;
      max-width: 420px;

      .liferecad-logo {
        width: auto;
        margin: 0 0 0 auto;
        height: 100%;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .news-files {
    .news-files-header {
      width: 100%;
    }
    &.liferecad {
      .news-files-table table tr td:first-child {
        padding-left: 0;
        padding-right: 5px;
        vertical-align: top;
      }
    }
  }
}
</style>
